import React from "react";
import Text from "../../components/Text";
import { fontSizes } from "../../constants/constants";
import ViewReverse from "../../components/ViewReverse";
import CustomSwitch from "../../components/CustomSwitch";
import CustomDropdown from "../../components/CustomDropdown";
import CustomInput from "../../components/CustomInput";
import Button from "../../components/Button";
import { rowReverseStylesm } from "../../utils/styles";
import CustomModal from "../../components/CustomModal";
import ViewItems from "../../components/ViewItems";
import Divider from "../../components/Divider";
import redeemFunctional from "./index.function";
import { Formik } from "formik";
import {
  partial_redemption_schema,
  partial_redemption_validation_schema,
  redemption_schema,
  redemption_validation_schema,
} from "../../validations_schemas/redemption_validation_schema";
import ErrorText from "../../components/ErrorText";
import {
  getFundHolding,
  getTradExDetails,
} from "../../store/actions/fund-action";
import OtpModal from "../../components/OtpModal";
import { formatNumbers } from "../../utils/utils";
import { unit_regix } from "../../utils/functions";

const Redeem = () => {
  const {
    TextWeight,
    isArabic,
    isPartial,
    dropdown_data,
    fund_loading,
    redeemData,
    isCompleted,
    setIsPartial,
    handleReview,
    getContentKey,
    onSubmitReview,
    dispatch,
    fund_holdings,
    reviewModal,
    toogleReviewModal,
    otpModal,
    toogleOtpModal,
    onVerifyOtp,
  } = redeemFunctional();

  return (
    <div>
      {!isCompleted ? (
        <Formik
          validationSchema={
            isPartial
              ? partial_redemption_validation_schema
              : redemption_validation_schema
          }
          initialValues={
            isPartial ? partial_redemption_schema : redemption_schema
          }
          onSubmit={(values, functions) => handleReview(values, functions)}
          validateOnBlur={false}
          validateOnChange={false}
        >
          {({
            handleSubmit,
            setFieldValue,
            values,
            resetForm,
            setFieldError,
            errors,
          }) => {
            const isValid =
              values?.asset_class &&
              values?.fund &&
              // values?.class &&
              values?.transfer;
            const partialValid =
              values?.asset_class &&
              values?.fund &&
              // values?.class &&
              values?.transfer &&
              (values?.redemption || values?.quantity);

            return (
              <>
                <Text
                  text={getContentKey("heading")}
                  size={fontSizes.h24}
                  weight={TextWeight.bold}
                  color="text-primary"
                />
                <Text
                  text={getContentKey("complete_redeem")}
                  size={fontSizes.h20}
                  weight={TextWeight.regular}
                  className={"mb-3"}
                  isTruncate={false}
                />

                <ViewReverse className={"gap-6 items-center"}>
                  <Text
                    text={getContentKey("redemption")}
                    size={fontSizes.h14}
                    color="text-primary-light"
                  />
                  <CustomSwitch
                    leftText={getContentKey("partial")}
                    rightText={getContentKey("total")}
                    checked={!isPartial}
                    onChange={() => {
                      setFieldValue("redemption", null);
                      setFieldValue("quantity", null);
                      setIsPartial(!isPartial);
                    }}
                    isRequired
                  />
                </ViewReverse>

                <ViewReverse
                  className={`gap-4 mt-4 flex-col ${rowReverseStylesm(
                    isArabic
                  )}`}
                >
                  <div className="w-full sm:w-1/2">
                    <CustomDropdown
                      label={getContentKey("asset_class")}
                      options={dropdown_data?.assetClassDataList}
                      selectedValue={values?.asset_class}
                      onSelect={(val) => {
                        setFieldValue("asset_class", val);
                        setFieldValue("fund", null);
                        setFieldError("asset_class", null);
                        setFieldValue("fund", null);
                        // setFieldValue("class", null);
                        setFieldValue("quantity", null);
                        setFieldValue("redemption", null);
                        setFieldValue("transfer", null);
                      }}
                      valueKey={"name"}
                      isError={errors?.asset_class}
                      isRequired
                    />
                    {errors?.asset_class && (
                      <ErrorText
                        text={errors?.asset_class}
                        getContentKey={getContentKey}
                      />
                    )}
                  </div>
                  <div className="w-full sm:w-1/2">
                    <CustomDropdown
                      label={getContentKey("portfolio")}
                      options={dropdown_data?.cashAccountList}
                      selectedValue={values?.portfolio}
                      onSelect={(val) => {
                        setFieldValue("portfolio", val);
                        setFieldError("portfolio", null);
                      }}
                      valueKey={"code"}
                      isError={errors?.fund}
                      isRequired
                    />
                    {errors?.fund && (
                      <ErrorText
                        text={errors?.fund}
                        getContentKey={getContentKey}
                      />
                    )}
                  </div>
                </ViewReverse>

                <ViewReverse
                  className={`gap-4 mt-4 flex-col ${rowReverseStylesm(
                    isArabic
                  )}`}
                >
                  {values?.asset_class?.code && values?.portfolio?.code && (
                    <div className="w-full sm:w-1/2">
                      <CustomDropdown
                        label={getContentKey("fund")}
                        options={dropdown_data?.fundDataList?.filter(
                          (item) =>
                            item?.assetClassCode == values?.asset_class?.code
                        )}
                        selectedValue={values?.fund}
                        onSelect={(val) => {
                          setFieldValue("fund", val);
                          setFieldError("fund", null);
                          dispatch(getTradExDetails(val?.fundCode));
                          dispatch(getFundHolding(`${val?.code}&portfolioId=${values?.portfolio?.clientPortfolioCode}`));
                        }}
                        valueKey={"name"}
                        isError={errors?.fund}
                        isRequired
                      />
                      {errors?.fund && (
                        <ErrorText
                          text={errors?.fund}
                          getContentKey={getContentKey}
                        />
                      )}
                    </div>
                  )}
                  <div className="w-full sm:w-1/2">
                    {/* {values?.fund?.id && (
                      <>
                        <CustomDropdown
                          label={getContentKey("class")}
                          options={dropdown_data?.classDataList?.filter(
                            (item) => item?.fundId === values?.fund?.id
                          )}
                          selectedValue={values?.class}
                          onSelect={(val) => {
                            setFieldValue("class", val);
                            setFieldError("class", null);
                          }}
                          valueKey={"name"}
                          isError={errors?.class}
                          isRequired
                        />
                        {errors?.class && (
                          <ErrorText
                            text={errors?.class}
                            getContentKey={getContentKey}
                          />
                        )}
                      </>
                    )} */}
                  </div>
                </ViewReverse>

                {isPartial && (
                  <>
                    <ViewReverse
                      className={`gap-4 mt-4 flex-col ${rowReverseStylesm(
                        isArabic
                      )}`}
                    >
                      <div className="w-full sm:w-1/2">
                        <CustomInput
                          label={getContentKey("redemption_amount")}
                          placeholder={getContentKey(
                            "redemption_amount_placeholder"
                          )}
                          isFullborder
                          isRounded
                          type="number"
                          value={values?.redemption}
                          onChange={(e) => {
                            setFieldValue("redemption", e?.target?.value);
                            setFieldError("redemption", null);
                            setFieldValue("quantity", "");
                          }}
                          isError={errors?.redemption}
                          isDisabled
                          isRequired
                        />
                        {errors?.redemption && (
                          <ErrorText
                            text={errors?.redemption}
                            getContentKey={getContentKey}
                          />
                        )}
                      </div>
                      <div className="w-full sm:w-1/2">
                        <Text
                          text={getContentKey("available_amount")}
                          color="text-primary-light"
                          size={fontSizes.h14}
                        />
                        <Text
                          text={`${formatNumbers(fund_holdings?.currentMarketValue)} SAR`}
                          color="text-grak-grey"
                          size={fontSizes.h14}
                          weight={TextWeight.light}
                          className={"mt-4"}
                        />
                      </div>
                    </ViewReverse>

                    <Text
                      text={getContentKey("or")}
                      size={fontSizes.h14}
                      color="text-primary-light mt-3"
                    />

                    <ViewReverse
                      className={`gap-4 mt-4 flex-col ${rowReverseStylesm(
                        isArabic
                      )}`}
                    >
                      <div className="w-full sm:w-1/2">
                        <CustomInput
                          label={getContentKey("units_redeem")}
                          placeholder={getContentKey("enter_quantity")}
                          isFullborder
                          isRounded
                          type="number"
                          value={values?.quantity}
                          onChange={(e) => {
                            const isUnit = unit_regix.test(e.target.value);

                            if (isUnit) {
                              setFieldValue("quantity", e.target.value);
                              setFieldValue("redemption", "");
                              setFieldError("quantity", null);
                            }
                          }}
                          isError={errors?.quantity}
                          isDisabled={values?.redemption ? true : false}
                          isRequired
                        />
                        {errors?.quantity && (
                          <ErrorText
                            text={errors?.quantity}
                            getContentKey={getContentKey}
                          />
                        )}
                      </div>
                      <div className="w-full sm:w-1/2">
                        <Text
                          text={getContentKey("available_unit")}
                          color="text-primary-light"
                          size={fontSizes.h14}
                        />
                        <Text
                          text={`${formatNumbers(fund_holdings?.totalUnits, 4)} SAR`}
                          color="text-grak-grey"
                          size={fontSizes.h14}
                          weight={TextWeight.light}
                          className={"mt-4"}
                        />
                      </div>
                    </ViewReverse>
                  </>
                )}

                <ViewReverse
                  className={`gap-4 mt-4 flex-col ${rowReverseStylesm(
                    isArabic
                  )}`}
                >
                  <div className="w-full sm:w-1/2">
                    <CustomDropdown
                      label={getContentKey("transfer_amount")}
                      options={dropdown_data?.cashAccountList}
                      selectedValue={values?.transfer}
                      onSelect={(val) => {
                        setFieldValue("transfer", val);
                        setFieldError("transfer", null);
                      }}
                      valueKey={"cashAccountName"}
                      isError={errors?.transfer}
                      isRequired
                    />
                    {errors?.transfer && (
                      <ErrorText
                        text={errors?.transfer}
                        getContentKey={getContentKey}
                      />
                    )}
                  </div>
                  <div className="w-full sm:w-1/2">
                    {!isPartial && (
                      <>
                        <Text
                          text={getContentKey("available_unit")}
                          color="text-primary-light"
                          size={fontSizes.h14}
                        />
                        <Text
                          text={`${
                            fund_holdings?.totalUnits
                              ? Number(
                                  Number(fund_holdings?.totalUnits)?.toFixed(4)
                                )?.toLocaleString()
                              : 0
                          } SAR`}
                          color="text-grak-grey"
                          size={fontSizes.h14}
                          weight={TextWeight.light}
                          className={"mt-4"}
                        />
                      </>
                    )}
                  </div>
                </ViewReverse>

                <Text text={getContentKey("redeem_disclaimer")} size={fontSizes.h14} className={"mt-3"} />

                <ViewReverse className="items-center w-full justify-end gap-4 mt-8">
                  <Button
                    text={getContentKey("clear_btn")}
                    bgColor="bg-white"
                    color={'text-primary'}
                    className={
                      "w-36 text-center border border-primary"
                    }
                    onClick={resetForm}
                  />
                  <Button
                    text={getContentKey("review_btn")}
                    bgColor="bg-primary"
                    className={"w-36 text-center"}
                    onClick={handleSubmit}
                    isDisabled={isPartial ? !partialValid : !isValid}
                  />
                </ViewReverse>
              </>
            );
          }}
        </Formik>
      ) : (
        <div className="w-full flex flex-col justify-center h-[50vh]">
          <div>
            <Text
              text={getContentKey("thank_you")}
              size={fontSizes.h24}
              weight={TextWeight.bold}
              color="text-primary"
            />
            <Text
              text={getContentKey("redeem_recieved")}
              size={fontSizes.h20}
              weight={TextWeight.regular}
              isTruncate={false}
            />
          </div>
        </div>
      )}

      <CustomModal
        heading={getContentKey("heading")}
        isOpen={reviewModal}
        isFullWidth
        onClose={toogleReviewModal}
      >
        <Text
          text={getContentKey("redeem_summary")}
          className={"mt-2"}
        />

        <ViewReverse className={"justify-between gap-4 mt-2"}>
          <ViewItems className={"w-1/2 sm:w-4/6 gap-2"}>
            <Divider margin="m-0" />
            <Text text={getContentKey("type")} size={fontSizes.h14} />
            <Divider margin="m-0" />
            {/* <Text text={getContentKey("fund")} size={fontSizes.h14} /> */}
            <Text
              text={getContentKey("class")}
              size={fontSizes.h14}
            />
            <Text
              text={
                isPartial
                  ? redeemData?.redemption
                    ? getContentKey("amount")
                    : getContentKey("units")
                  : getContentKey("units")
              }
              size={fontSizes.h14}
            />
            <Divider margin="m-0" />
            <Text text={getContentKey("date")} size={fontSizes.h14} />
          </ViewItems>
          <ViewItems className={"w-1/2 sm:w-full gap-2"}>
            <Divider margin="m-0" />
            <Text text={isPartial ? getContentKey("partial") : getContentKey("total")} size={fontSizes.h14} />
            <Divider margin="m-0" />
            <Text
              text={redeemData?.fund?.name}
              size={fontSizes.h14}
              className={"w-full"}
            />
            {/* <Text text={redeemData?.class?.name} size={fontSizes.h14} className={"w-full"} /> */}
            <Text
              text={isPartial ? 
                redeemData?.redemption
                  ? formatNumbers(redeemData?.redemption)
                  : formatNumbers(redeemData?.quantity, 4)
              : formatNumbers(fund_holdings?.totalUnits, 4)}
              size={fontSizes.h14}
            />
            <Divider margin="m-0" />
            <Text text={new Date().toLocaleDateString()} size={fontSizes.h14} />
            <Divider margin="m-0" />
          </ViewItems>
        </ViewReverse>

        <ViewReverse className="items-center w-full justify-end gap-2 mt-3">
          <Button
            text={getContentKey("edit")}
            color={"text-primary"}
            bgColor="bg-white"
            className={
              "border border-primary w-32 px-0 text-center"
            }
            onClick={toogleReviewModal}
          />
          <Button
            text={getContentKey("submit")}
            bgColor="bg-primary"
            className={"w-32 px-0 text-center border border-orange"}
            onClick={onSubmitReview}
            loading={fund_loading}
          />
        </ViewReverse>
      </CustomModal>

      <OtpModal
        open={otpModal}
        onClose={toogleOtpModal}
        onVerify={onVerifyOtp}
      />
    </div>
  );
};

export default Redeem;
